<template>
    <div class="dataStatistics">
        <div class="title-box">
            <img class="cion" src="@/assets/home/dateLeft-icon.png"></img>
            <span>游客区域</span>
        </div>
        <div class="cont-box2">
            <chartLine :chartData="chartData" height="267px"></chartLine>
        </div>
    </div>
</template>

<script>
    import drawMixin from "@/utils/drawMixin";
    import chartLine from '@/components/home/chartLine.vue';

    import {
        formatTime
    } from "@/utils/index.js";
    import { statistics } from '@/api/common.js'
    export default {
        // mixins: [drawMixin],
        data() {
            return {
                num: '232',
                chartData: {},
            };
        },
        components: {
            chartLine
        },
        mounted() {


        },
        beforeDestroy() {

        },
        created() {
            this.init()
        },
        methods: {
            init() {
                let obj = {
                    xAxis: [],
                    data: [],
                }
                // 地区统计
                statistics().then(res => {
                    console.log('2222', res)
                    if (res.code == 200) {
                        let list = res.data.provinceStatistics
                        list.forEach(item => {
                            obj.xAxis.push(item.provinceName)
                            obj.data.push(item.guestCount)
                        })
                        this.chartData = obj
                    }
                })
            }
        },
    };
</script>

<style lang="scss" scoped>
    /* @import "../../../assets/scss/index.scss"; */

    .dataStatistics {
        /* background-image: url(../../../assets/home/bg-1.png); */
        background: linear-gradient( 180deg, rgba(32,65,116,.3) 0%, rgba(113,161,246,.3) 100%);
        background-size: 100% 100%;
        margin-bottom: 10px;

        .title-box {
            width: 100%;
            height: 42px;
            background-image: url(../../../assets/home/title-box-bg.png);
            background-size: 100% 100%;
            font-family: Alimama ShuHeiTi, Alimama ShuHeiTi;
            font-weight: bold;
            font-size: 16px;
            color: #FFFFFF;
            display: flex;
            align-items: center;

            .cion {
                width: 34px;
                height: 35px;
                margin-right: 10px;
            }
        }

        .cont-box2 {
            width: 100%;
            padding: 13px 20px 10px 20px;
        }





    }
</style>